<div class="flexie-auto-grid p-b-20" [class.m-t-30]="mode =='drawer'">
  <div>
    <h1 *ngIf="transactionState != 'cacheClean'"><strong>Search
        {{configData?.TransactionDetailsMetaData[transactionState]
        ? configData.TransactionDetailsMetaData[transactionState].tableHeading : "data" }}</strong></h1>
    <i style="font-size: 10px;"><i nz-icon nzType="exclamation-circle" class="ico-item"></i> By using the criteria from
      dropdown below you can search existing
      {{configData?.TransactionDetailsMetaData[transactionState]
      ? configData.TransactionDetailsMetaData[transactionState].tableHeading : "data"}}.</i>
    <h2 *ngIf="transactionState == 'cacheClean'">Clear Cache</h2>
    <div class="m-t-10">
      <app-ui-search *ngIf="transactionState != 'cacheClean'"
        [itemsPerPage]="configData?.TransactionDetailsMetaData[transactionState]?.itemsPerPage"
        [(SearchCriteria)]="CRITERIALOOKUP" (componentOutput)="fetchSearchResult($event)"
        [extraExternalParams]="extraExternalParams" (criteriaOutput)="getSelectedCriteria($event)"
        [searchURL]="configData?.TransactionDetailsMetaData[transactionState]?.searchURL"></app-ui-search>
    </div>
  </div>
  <div *ngIf="transactionState != 'cacheClean'" class="text-a-right">
    <button *ngIf="transactionState == 'rule' && appMetadataHandler.featureFlags.enableRuleTesting" class="m-r-10"
      nz-button [nzType]="'primary'" (click)="openRuleTestingModal()">Rule Testing</button>
    <button *ngIf="configData.TransactionDetailsMetaData[transactionState].buttonName" nz-button [nzType]="'primary'"
      (click)="openNewTransaction()" [disabled]="!isUserPrivileged">
      <i nz-icon nzType="plus" nzTheme="outline"></i>{{configData?.TransactionDetailsMetaData[transactionState]
      ? configData.TransactionDetailsMetaData[transactionState].buttonName : "New" }}</button>

    <!-- <nz-dropdown *ngIf="transactionState=='product'" class="m-r-10" [nzPlacement]="'bottomLeft'">
            <button nz-button [nzType]="'primary'" nz-dropdown>
                <i nz-icon nzType="plus"
                    nzTheme="outline"></i>{{configData?.TransactionDetailsMetaData[transactionState]
                ? configData.TransactionDetailsMetaData[transactionState].buttonName : "New" }}</button>
            <ul nz-menu>
                <li nz-submenu nzTitle="Standard Product" (click)="openNewTransaction()"></li>
                <li nz-submenu nzTitle="Template Product" (click)="openNewTransaction()">
                </li>
            </ul>
        </nz-dropdown> -->
  </div>
  <div *ngIf="transactionState == 'cacheClean'" class="text-a-right">
    <button nz-button [nzType]="'primary'" (click)="clearCache()">
      <i nz-icon nzType="plus" nzTheme="outline"></i>Clear All</button>
  </div>
</div>

<div *ngIf="transactionState != 'cacheClean'">
  <div class="heading-tab p-t-5 p-b-15">
    <h3 class="heading" translate>{{headingPrefix}} {{configData?.TransactionDetailsMetaData[transactionState]
      ? configData.TransactionDetailsMetaData[transactionState].tableHeading : "Transactions" }}
      ({{searchResultsList.length}})</h3>

    <div>
      <button *ngIf="env['implementationName'] != 'MLifeHK'" class="m-5" nz-button nzType="primary" (click)="createTemplateExcel()"><i nz-icon
          nzType="download"></i></button>
      <button nz-button nz-dropdown nzPlacement="topCenter" [nzDropdownMenu]="manageHeadersMenu">View/Hide
        Columns<i nz-icon nzType="down"></i></button>
      <nz-dropdown-menu #manageHeadersMenu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item
            *ngFor="let config of columnDefs">
            <label nz-checkbox [nzDisabled]="lastCheckboxPendingToBeUnticked() && config.isVisible"
              [(ngModel)]="config.isVisible" (ngModelChange)="manageHeaders($event)">{{config.header}}</label>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
  </div>
  <!-- <nz-skeleton [nzActive]="true" [nzLoading]="searchDataIsInProcess"> -->
  <nz-skeleton *ngIf="appMetadataHandler.featureFlags.enableAGGrid && !rowData" [nzAvatar]="false" [nzActive]="true"
    [nzTitle]="true" [nzLoading]="!rowData">
  </nz-skeleton>
  <div *ngIf="appMetadataHandler.featureFlags.enableAGGrid && rowData">
    <span *ngIf="!env.production && !configData.TransactionDetailsMetaData[transactionState]['actionList']" class="actions-text">
      <p><i nz-icon nzType="exclamation-circle" class="ico-item m-r-5"></i>Message for Developers: If you want to add/remove actions, please configure
        it in the configurator-transaction.json file, under respective transaction state</p>
    </span>
    <ag-grid-angular class="ag-theme-alpine" [rowData]="rowData" [columnDefs]="columnDefs"
      [defaultColDef]="defaultColumnDefs" [pagination]="true" [animateRows]="true" [paginationPageSize]="paginationPageSize"
      [suppressExcelExport]="true" [rowSelection]="rowSelection" style="height: 320px;">
    </ag-grid-angular>
  </div>

  <nz-table *ngIf="!appMetadataHandler.featureFlags.enableAGGrid" #genericSearchTable [nzData]="searchResultsList" [nzSize]="'default'"
  [nzLoading]="searchDataIsInProcess" [nzScroll]="{ x: configData.TransactionDetailsMetaData[transactionState].scrollValue }">
    <thead (nzSortOrderChange)="sort($event)" nzSingleSort>
      <tr>
        <ng-container
          *ngFor="let config of columnDefs;let index = i">
          <th scope="col" [nzWidth]="config.width"
            *ngIf="config.isVisible && (!config.searchFilter && !config.sortFilter)">
            {{config.header}}</th>
          <th scope="col" [nzWidth]="config.width"
            *ngIf="config.isVisible && (config.searchFilter && config.sortFilter)" nzCustomFilter nzShowSort
            [nzColumnKey]="config.key">
            {{config.header}}
            <nz-filter-trigger [nzDropdownMenu]="menu" (nzVisibleChange)="filterMenuVisibilityChanged($event)">
              <i nz-icon nzType="search" (click)="getConfigKey(config.key)"></i>
            </nz-filter-trigger>
            <!-- <i nz-th-extra class="ant-table-filter-icon" nz-icon nz-dropdown #dropdown="nzDropdown" nzType="search"
              [nzDropdownMenu]="menu" [class.ant-table-filter-open]="dropdown.nzVisible" nzTrigger="click"
              nzPlacement="bottomRight" [nzClickHide]="true" nzTableFilter (click)="getConfigKey(config.key)"></i> -->
          </th>
          <th scope="col" [nzWidth]="config.width"
            *ngIf="config.isVisible && (config.searchFilter && !config.sortFilter)" nzCustomFilter>
            {{config.header}}
            <nz-filter-trigger [nzDropdownMenu]="menu" (nzVisibleChange)="filterMenuVisibilityChanged($event)">
              <i nz-icon nzType="search" (click)="getConfigKey(config.key)"></i>
            </nz-filter-trigger>
            <!-- <i nz-th-extra class="ant-table-filter-icon" nz-icon nz-dropdown #dropdown="nzDropdown" nzType="search"
              [nzDropdownMenu]="menu" [class.ant-table-filter-open]="dropdown.nzVisible" nzTrigger="click"
              nzPlacement="bottomRight" [nzClickHide]="true" nzTableFilter (click)="getConfigKey(config.key)"></i> -->
          </th>
          <th scope="col" *ngIf="config.isVisible && (!config.searchFilter && config.sortFilter)" nzShowSort
            [nzSortKey]="config.key">
            {{config.header}}</th>
        </ng-container>
        <th scope="col" nzRight="0px" style="width: 100px;">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of genericSearchTable.data">
        <ng-container
          *ngFor="let config of columnDefs;let index = i">
          <td [ngClass]="config.textEllipsis ? 'text-ellipsis' : 'break-word'"
            *ngIf="config.key !='version' && config.isVisible">
            <span [title]="data[config.key]" *ngIf="!config.pipe">{{data[config.key]}}</span>
            <span [title]="(config.key=='vocabularyType' &&
                            data[config.key]==='SYSTEM')? 'System':
                            (data[config.key] | technicalTranslate)"
              *ngIf="config.pipe && (config.pipe == 'technicalTranslate' && !config.pipeValue)">{{(config.key=='vocabularyType'
              &&
              data[config.key]==='SYSTEM')?'System':(data[config.key] |
              technicalTranslate)}}</span>

            <span [title]="(config.key=='vocabularyType' &&
              data[config.key]==='SYSTEM')? 'System':
              (data[config.key] | technicalTranslate)"
              *ngIf="config.pipe && (config.pipe == 'technicalTranslate' && config.pipeValue)">{{(config.key=='vocabularyType'
              &&
              data[config.key]==='SYSTEM')?'System':(data[config.key] |
              technicalTranslate: config.pipeValue)}}</span>

            <span *ngIf="data[config.key] && config.pipe && config.pipe == 'date'">{{(data[config.key] | date :
              appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR)}}</span>

            <span *ngIf="data[config.key] && config.pipe && config.pipe == 'CurrencyFormatter'">{{(data[config.key] | CurrencyFormatter : (data.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue))}}</span>

            <span *ngIf="!data[config.key]" class="nodatafound">No data found</span>
          </td>

          <td *ngIf="config.key =='version' && config.isVisible ">
            <span *ngIf="data[config.key]">V&nbsp;{{data[config.key]}}</span>
            <span *ngIf="!data[config.key]" class="nodatafound">No data found</span>
          </td>
        </ng-container>
        <td *ngIf="transactionState!='rule' && transactionState!='bulk-upload'" nzRight="0px">
          <span *ngIf="(isUserPrivileged || isHKUserPrivileged)">
            <!-- <a (click)="editTransaction(data,'VIEW')">View</a> -->
            <a *ngIf="(isUserPrivileged || isHKUserPrivileged) && !(data && data.workflowStatusCd && (data.workflowStatusCd == 'Publish') || (data.workflowStatusCd == 'PUBLISH'))" (click)="editTransaction(data,'EDIT')"
              [ngClass]="{'anch-disable' : (data[configData.TransactionDetailsMetaData[transactionState].disabledKey] ? data[configData.TransactionDetailsMetaData[transactionState].disabledKey] : 1) == (configData.TransactionDetailsMetaData[transactionState].disabledValue ? configData.TransactionDetailsMetaData[transactionState].disabledValue : 0)}"><span>
                | </span>Edit</a>
            <!-- <a *ngIf="isUserPrivileged && transactionState =='contextDefinition' && data.contextType !=='PRODUCT'" (click)="editTransaction(data)" class=".anchors-are-disabled a"><span> | </span>Edit</a> -->
          </span>	
          <span *ngIf="false">
            <a>Remove</a>
          </span>
        </td>
        <td *ngIf="transactionState =='bulk-upload'" nzRight="0px">
          <span>
            <a (click)="editTransaction(data,'VIEW')">Clone</a>
            <!-- <a *ngIf="isUserPrivileged && transactionState =='contextDefinition' && data.contextType !=='PRODUCT'" (click)="editTransaction(data)" class=".anchors-are-disabled a"><span> | </span>Edit</a> -->
          </span>
          <span *ngIf="false">
            <a>Remove</a>
          </span>
        </td>
        <td *ngIf="transactionState=='rule'" nzRight="0px">
          <a nz-dropdown [nzDropdownMenu]="menu">Actions
            <i nz-icon nzType="down"></i>
          </a>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu nzSelectable>
              <li *ngIf="isUserPrivileged && (data && data.workflowStatusCd && (data.workflowStatusCd == 'Draft' || data.workflowStatusCd == 'DRAFT'))" nz-menu-item (click)="editTransaction(data)">Edit Rule</li>
              <li nz-menu-item (click)="viewRule(data, 'viewRule')">View Rule</li>
              <li nz-menu-item (click)="viewRule(data, 'viewRuleAudit')">View Rule Audit</li>
            </ul>
          </nz-dropdown-menu>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <!---Older Version of ng-zorro (8.x)--->
  <!-- <nz-table #genericSearchTable [nzData]="searchResultsList" [nzSize]="'default'"
    [nzScroll]="{ x: configData.TransactionDetailsMetaData[transactionState].searchTableHeaders.length>5?'2400px':null }">
    <thead (nzSortOrderChange)="sort($event)" nzSingleSort>
      <tr>
        <ng-container
          *ngFor="let config of configData.TransactionDetailsMetaData[transactionState].searchTableHeaders;let index = i">
          <th scope="col" *ngIf="config.isVisible && (!config.searchFilter && !config.sortFilter)">{{config.header}}</th>
          <th scope="col" *ngIf="config.isVisible && (config.searchFilter && config.sortFilter)" nzCustomFilter nzShowSort
            [nzColumnKey]="config.key">
            {{config.header}}
            <i nz-th-extra class="ant-table-filter-icon" nz-icon nz-dropdown #dropdown="nzDropdown" nzType="search"
              [nzDropdownMenu]="menu" [class.ant-table-filter-open]="dropdown.nzVisible" nzTrigger="click"
              nzPlacement="bottomRight" [nzClickHide]="true" nzTableFilter (click)="getConfigKey(config.key)"></i>
          </th>
          <th scope="col" *ngIf="config.isVisible && (config.searchFilter && !config.sortFilter)" nzCustomFilter>
            {{config.header}}
            <i nz-th-extra class="ant-table-filter-icon" nz-icon nz-dropdown #dropdown="nzDropdown" nzType="search"
              [nzDropdownMenu]="menu" [class.ant-table-filter-open]="dropdown.nzVisible" nzTrigger="click"
              nzPlacement="bottomRight" [nzClickHide]="true" nzTableFilter (click)="getConfigKey(config.key)"></i>
          </th>
          <th scope="col" *ngIf="config.isVisible && (!config.searchFilter && config.sortFilter)" nzShowSort
            [nzSortKey]="config.key">
            {{config.header}}</th>
        </ng-container>
        <th scope="col" nzRight="0px" style="width: 100px;">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of genericSearchTable.data">
        <ng-container
          *ngFor="let config of configData.TransactionDetailsMetaData[transactionState].searchTableHeaders;let index = i">
          <td *ngIf="config.key !='version' && config.isVisible">
            <span class="break-word" *ngIf="!config.pipe">{{data[config.key]}}</span>
            <span *ngIf="config.pipe && config.pipe == 'technicalTranslate'"
              class="break-word">{{(config.key=='vocabularyType' &&
              data[config.key]==='SYSTEM')?'System':(data[config.key] |
              technicalTranslate)}}</span>

            <span *ngIf="data[config.key] && config.pipe && config.pipe == 'date'"
              class="break-word">{{(data[config.key] |date :
              appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR:'GMT')}}</span>

            <span *ngIf="!data[config.key]" class="nodatafound">No data found</span>
          </td>

          <td *ngIf="config.key =='version' && config.isVisible ">
            <span *ngIf="data[config.key]" class="break-word">V&nbsp;{{data[config.key]}}</span>
            <span *ngIf="!data[config.key]" class="nodatafound">No data found</span>
          </td>
        </ng-container>
        <td *ngIf="transactionState!='rule' && transactionState!='bulk-upload'" nzRight="0px">
          <span>
            <a (click)="editTransaction(data,'VIEW')">View</a>
            <a *ngIf="isUserPrivileged" (click)="editTransaction(data)"
              [ngClass]="{'anch-disable' : (data[configData.TransactionDetailsMetaData[transactionState].disabledKey] ? data[configData.TransactionDetailsMetaData[transactionState].disabledKey] : 1) == (configData.TransactionDetailsMetaData[transactionState].disabledValue ? configData.TransactionDetailsMetaData[transactionState].disabledValue : 0)}"><span>
                | </span>Edit</a>
            
          </span>
          <span *ngIf="false">
            <a>Remove</a>
          </span>
        </td>
        <td *ngIf="transactionState =='bulk-upload'" nzRight="0px">
          <span>
            <a (click)="editTransaction(data,'VIEW')">Clone</a>
             </span>
          <span *ngIf="false">
            <a>Remove</a>
          </span>
        </td>
        <td *ngIf="transactionState=='rule'" nzRight="0px">
          <a nz-dropdown [nzDropdownMenu]="menu">Select Action
            <i nz-icon nzType="down"></i>
          </a>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu nzSelectable>
              <li *ngIf="isUserPrivileged" nz-menu-item (click)="editTransaction(data)">Edit Rule</li>
              <li nz-menu-item (click)="viewRule(data, 'viewRule')">View Rule</li>
              <li nz-menu-item (click)="viewRule(data, 'viewRuleAudit')">View Rule Audit</li>
            </ul>
          </nz-dropdown-menu>
        </td>
      </tr>
    </tbody>
  </nz-table> -->

  <nz-dropdown-menu #menu="nzDropdownMenu">
    <div class="ant-table-filter-dropdown">
      <div class="search-box">
        <input type="text" nz-input placeholder="Filter..." [(ngModel)]="searchValue" />
        <button nz-button nzSize="small" nzType="primary" (click)="searchConfiguration(searchValue)"
          class="search-button">
          Filter
        </button>
        <button nz-button nzSize="small" (click)="reset()">Reset</button>
      </div>
    </div>

    <!---Older Version of ng-zorro (8.x)--->
    <!-- <div class="search-box">
      <input type="text" nz-input placeholder="Filter..." [(ngModel)]="searchValue" />
      <button nz-button nzSize="small" nzType="primary" (click)="searchConfiguration(searchValue)"
        class="search-button">
        Filter
      </button>
      <button nz-button nzSize="small" (click)="reset()">Reset</button>
    </div> -->
  </nz-dropdown-menu>
<!-- </nz-skeleton> -->
  <!-- <app-generic-zero-ui *ngIf="searchResultsList.length==0" [list]="searchResultsList" icon="file-search"
        [title]="searchConfigurationZeroState.title" [message]="searchConfigurationZeroState.message"
        [icon]="searchConfigurationZeroState.icon"></app-generic-zero-ui> -->
</div>

<div>
  <!-- message('Properties Updated');clearSelected() -->
  <nz-modal [(nzVisible)]="ruleAuditModal" (nzOnCancel)="ruleAuditModal=false;" [nzOkText]="'Ok'" nzWidth="80%"
    [nzCancelText]="'Close'" (nzOnOk)="ruleAuditModal=false;" [nzZIndex]="1001" nzMaskClosable="false">
    <div class="m-t-20" *ngIf="ruleAuditModal">
      <app-rule-audit [viewRuleArr]="viewRuleArr" [viewAuditRuleArr]="viewAuditRuleArr" [mode]="ruleMode">
      </app-rule-audit>
    </div>
    <!-- <div *ngIf="'task'"> -->
    <!-- <app-new-rule [config]="configData" [transactionState]="'rule'" [editMode]="editMode"
                [IO]="taskRules"></app-new-rule> -->
    <!-- <app-transaction-details></app-transaction-details> -->
    <!-- inside task -->
    <!-- </div> -->
  </nz-modal>
</div>

<!--Rule Testing Popup-->
<nz-modal [(nzVisible)]="showRuleTestingModal" [nzTitle]="'Rule Testing'" nzClosable [nzMaskClosable]="false"
  nzCancelText="Close" [nzOkText]="null" (nzOnCancel)="closeRuleTestingModal()" nzWidth="80vw">


</nz-modal>
<!--Enf of Rule Testing Popup-->
